 <mat-expansion-panel class="lg-panel goal-header exp-button-lg" [appResponsiveGauge]="gaugeConfig">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <div class="maintitle">
                <strong><span class="panel-title">{{ title }}</span>&nbsp;<span class="title-num">[{{ items.length }}]</span></strong>
            </div>
            <div class="subtitle" *ngIf="subtitle">
                {{ subtitle }}
            </div>
            <div class="subtitle title-dark" *ngIf="panelType === goalPanelTypes.CompetencyResult && getResultStartDate() && getResultEndDate()">
                {{ getResultStartDate() | datePlain }} - {{ getResultEndDate() | datePlain }}
            </div>
        </mat-panel-title>
        <mat-panel-description *ngIf="panelType === goalPanelTypes.TextBasedGoals || panelType === goalPanelTypes.NumericGoals || panelType === goalPanelTypes.CompetencyResult">

            <ng-container *ngIf="hasIndicators">
                <ngx-gauge #itemGauge type="full" [ngClass]="{'no-value': panelResult === null }"
                        [value]="panelResult | number: '1.0-0'" 
                        label=""
                        [thick]="5"
                        foregroundColor="#17A5E3"
                        append="%">
                </ngx-gauge>
    
                <app-weight-indicator [weight]="panelWeight" [size]="itemGauge.size"></app-weight-indicator>
            </ng-container>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- expansion content -->

    <ng-container *ngIf="panelType === goalPanelTypes.TextBasedGoals">
        <ng-container *ngFor="let item of goalPeriod.textBasedGoals; let i = index">
            <div class="gradient-separator"></div>
            <app-goal-view [goal]="item" [goalPeriod]="goalPeriod" (delete)="onGoalDelete(item, i)"></app-goal-view>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="panelType === goalPanelTypes.NumericGoals">
        <ng-container *ngFor="let item of goalPeriod.numericGoals; let i = index">
            <div class="gradient-separator"></div>
            <app-goal-view [goal]="item" [goalPeriod]="goalPeriod" (delete)="onGoalDelete(item, i)"></app-goal-view>
        </ng-container>
    </ng-container>
    
    <app-goal-competency-result-selector *ngIf="panelType === goalPanelTypes.CompetencyResult" [goalPeriod]="goalPeriod"></app-goal-competency-result-selector>
    
    <app-goal-custom-goals *ngIf="panelType === goalPanelTypes.CustomGoals && reviewPeriodCustomGoal" [reviewPeriodCustomGoal]="reviewPeriodCustomGoal" [goalPeriod]="goalPeriod"></app-goal-custom-goals>

    <ng-container *ngIf="panelType === goalPanelTypes.GroupGoals">
        <div class="gradient-separator" *ngIf="goalPeriod.groupGoals.length > 0"></div>
        <ng-container *ngFor="let item of goalPeriod.groupGoals; let i = index">
            <app-group-goal-view [groupGoal]="item" [goalPeriod]="goalPeriod" (delete)="onDeleteGroupGoal($event, i)"></app-group-goal-view>
        </ng-container>
        <div class="gradient-separator"></div>
    </ng-container>

     <!-- button bar -->

    <!-- <div class="action-button-panel" *ngIf="panelType === goalPanelTypes.TextBasedGoals || panelType === goalPanelTypes.NumericGoals">
        <button mat-flat-button color="primary" class="new-button" [disabled]="!allowNew()" (click)="onNewGoal()">ÚJ ÉRTÉKELÉSCSOPORT</button>
    </div> -->

    <div class="action-button-panel" *ngIf="panelType === goalPanelTypes.GroupGoals">
        <button mat-flat-button color="primary" class="new-button" [disabled]="!allowEditGroupGoals()" (click)="onEditGroupGoals()">{{ 'GOAL_PANEL.EDIT' | translate }}</button>
    </div>

</mat-expansion-panel>
